const { getElement, getElements } = window.BAO.Utils

class ResultsFilters extends window.BAO.CustomElement() {
  constructor () {
    super()
    this.eventBus = window.theme.nosto.eventBus
    this.events = window.theme.results.events
    this.sortOptions = window.theme.results.stateLayer.state.sort
    this.lastFacets = null
    this.lastActiveFacets = null
    this.updatedPreviousButton = false
  }

  connectedCallback () {
    super.connectedCallback()

    this.subscribeToEvents()
  }

  setupListeners () {
    super.setupListeners()

    // Global click handler
    this.handleClick = this.handleClick.bind(this)
    this.listeners.add(this, 'click', this.handleClick)

    // Form
    this.debouncedFormUpdate = window.BAO.Utils.debounce(
      (event) => this.handleFormUpdate(event),
      250,
    )

    this.listeners.add(this, 'input', this.debouncedFormUpdate.bind(this))
  }

  subscribeToEvents () {
    // Facets
    this.onFacetsUpdated = ({ facets, activeFacets }) => {
      this.lastFacets = facets
      this.lastActiveFacets = activeFacets
      this.renderFauxFacets(facets)
      this.renderActiveFacets(activeFacets)
      this.renderFacets(facets)
    }

    this.eventBus.subscribe(
      this.events.STATE.FACETS_UPDATED,
      this.onFacetsUpdated,
    )

    // Pagination
    this.onPaginationUpdated = (pagination) => {
      this.renderPagination(pagination)
    }

    this.onPaginationUpdated = this.onPaginationUpdated.bind(this)

    this.eventBus.subscribe(
      this.events.STATE.PAGINATION_UPDATED,
      this.onPaginationUpdated,
    )

    // Shopify fallback
    this.renderShopifyFallback = this.renderShopifyFallback.bind(this)

    this.eventBus.subscribe(
      this.events.API.SHOPIFY_FALLBACK,
      this.renderShopifyFallback,
    )
  }

  disconnectedCallback () {
    this.eventBus.unsubscribe(
      this.events.STATE.FACETS_UPDATED,
      this.onFacetsUpdated,
    )

    this.eventBus.unsubscribe(
      this.events.STATE.ACTIVE_FACETS_UPDATED,
      this.onActiveFacetsUpdated,
    )

    this.eventBus.unsubscribe(
      this.events.STATE.PAGINATION_UPDATED,
      this.onPaginationUpdated,
    )

    this.eventBus.unsubscribe(
      this.events.API.SHOPIFY_FALLBACK,
      this.renderShopifyFallback,
    )
  }

  handleClick (event) {
    const fauxFacetSelector = '[data-results-filters-el="fauxFacetTrigger"]'
    const fauxFacetEl = event.target.closest(fauxFacetSelector)

    if (fauxFacetEl) {
      this.handleFauxFacet(fauxFacetEl)
      return
    }

    const resetSelector =
      '[data-results-filters-el="reset"], .clc-ProductGrid_EmptyLink'
    const resetEl = event.target.closest(resetSelector)

    if (resetEl) {
      event.preventDefault()
      this.handleReset()
      return
    }

    const loadMoreSelector = '[data-results-filters-el="loadMore"]'
    const loadMoreEl = event.target.closest(loadMoreSelector)

    if (loadMoreEl) {
      this.handleLoadMore()
      return
    }

    const loadPreviousSelector = '[data-results-filters-el="loadPrevious"]'
    const loadPreviousEl = event.target.closest(loadPreviousSelector)

    if (loadPreviousEl) {
      this.handleLoadPrevious()
    }
  }

  handleFauxFacet (fauxFacetEl) {
    const drawerAccordionTriggerEls = this.querySelectorAll(
      `[data-accordion-group-el="trigger"]`,
    )
    const drawerAccordionContentEls = this.querySelectorAll(
      `[data-accordion-group-el="content"]`,
    )

    drawerAccordionTriggerEls.forEach((triggerEl) => {
      triggerEl.setAttribute(
        'aria-expanded',
        triggerEl.getAttribute('aria-controls') ===
          fauxFacetEl.dataset.accordion,
      )
    })

    drawerAccordionContentEls.forEach((contentEl) => {
      contentEl.setAttribute(
        'aria-hidden',
        contentEl.getAttribute('id') !== fauxFacetEl.dataset.accordion,
      )
    })
  }

  handleReset () {
    this.eventBus.publish(this.events.UI.FACET_CLEAR_ALL)
  }

  handleLoadMore () {
    this.eventBus.publish(this.events.UI.PAGINATION_NEXT, {
      direction: 'next',
    })
  }

  handleLoadPrevious () {
    this.eventBus.publish(this.events.UI.PAGINATION_PREVIOUS, {
      direction: 'previous',
      from: Number(this.els.loadPrevious.element.dataset.from) || 0,
      page: Number(this.els.loadPrevious.element.dataset.page) || 1,
    })

    // Update data so it's correct for new page
    this.els.loadPrevious.element.dataset.from =
      this.els.loadPrevious.element.dataset.from -
      window.theme.results.stateLayer.state.pagination.size

    this.els.loadPrevious.element.dataset.page =
      this.els.loadPrevious.element.dataset.page - 1
  }

  handleFormUpdate (event) {
    event.preventDefault()

    const type = event.target.type
    const name = event.target.name

    if (type === 'hidden') {
      this.handlePriceInput()
      return
    }

    if (name === 'sort_by') {
      this.handleSortInput(event.target)
      return
    }

    if (type === 'checkbox' || type === 'radio') {
      this.handleInput(event.target)
    }
  }

  handlePriceInput () {
    const options = { context: this.els.form.element }
    const minEl = getElement('[data-results-filters-el="min"]', options)
    const maxEl = getElement('[data-results-filters-el="max"]', options)

    this.eventBus.publish(this.events.UI.PRICE_CHANGED, {
      min: minEl ? minEl.value : '',
      max: maxEl ? maxEl.value : '',
    })
  }

  handleSortInput (inputEl) {
    const [field, order] = inputEl.value.split('~')

    this.eventBus.publish(this.events.UI.SORT_CHANGED, {
      field,
      order,
    })
  }

  handleInput (inputEl) {
    const value = [inputEl.value]
    const field = inputEl.getAttribute('name')

    if (inputEl.checked === true) {
      this.eventBus.publish(this.events.UI.FACET_ADDED, { field, value })
    } else {
      this.eventBus.publish(this.events.UI.FACET_REMOVED, { field, value })
    }
  }

  renderFauxFacets (facets) {
    if (!this.els.fauxFacets?.exists) return

    this.els.fauxFacets.element.innerHTML = ''

    const limit = Number(this.els.fauxFacets.element.dataset.limit) || 3
    const fauxFacets = facets.slice(0, limit)

    fauxFacets.forEach((facet, index) => {
      this.els.fauxFacets.element.insertAdjacentHTML(
        'beforeend',
        window.templates.FauxFacet(facet, index),
      )
    })
  }

  renderActiveFacets (facets) {
    if (facets.length) {
      this.els.activeFacets.element.removeAttribute('hidden')
    } else {
      this.els.activeFacets.element.setAttribute('hidden', '')
    }

    this.els.activeFacetsInner.element.innerHTML = ''

    facets.forEach((facet) => {
      this.els.activeFacetsInner.element.insertAdjacentHTML(
        'beforeend',
        window.templates.ActiveFacet(facet),
      )
    })

    // Update facet count
    let activeCount = 0

    facets.forEach((facet) => {
      activeCount += facet.value.length
    })

    this.els.facetsCount.element.textContent = activeCount
      ? `(${activeCount})`
      : ''
  }

  renderFacets (facets) {
    // Capture open accordions and scroll position so they can be restored
    let accordions = getElements(
      '[data-results-filters-el="facet"][data-accordion-group-el="trigger"]',
      { context: this.els.facets.element },
    )

    const openAccordions = accordions
      .filter((accordionEl) => {
        return accordionEl.getAttribute('aria-expanded') === 'true'
      })
      .map((accordionEl) => {
        return accordionEl.getAttribute('aria-controls')
      })

    const scrollPosition = this.els.facetsDrawer.element.scrollTop

    // Update template
    this.els.facets.element.innerHTML = ''

    facets.forEach((facet, index) => {
      this.els.facets.element.insertAdjacentHTML(
        'beforeend',
        window.templates.FacetAccordion(facet, index),
      )
    })

    this.els.facets.element.insertAdjacentHTML(
      'beforeend',
      window.templates.SortAccordion(this.sortOptions),
    )

    // Restore accordions and scroll position unless no facets are active anymore
    if (!this.lastActiveFacets.length || !openAccordions.length) return

    this.els.facetsDrawer.element.classList.add(
      'drw-ProductGridFacets_Accordion-noTransition',
    )

    accordions = getElements('[data-results-filters-el="facet"]', {
      context: this.els.facets.element,
    })

    accordions.forEach((accordionEl) => {
      const id = accordionEl.id || accordionEl.getAttribute('aria-controls')

      if (!openAccordions.includes(id)) return

      if (accordionEl.dataset.accordionGroupEl === 'trigger') {
        accordionEl.setAttribute('aria-expanded', true)
      }

      if (accordionEl.dataset.accordionGroupEl === 'content') {
        accordionEl.setAttribute('aria-hidden', false)
      }
    })

    requestAnimationFrame(() => {
      this.els.facetsDrawer.element.classList.remove(
        'drw-ProductGridFacets_Accordion-noTransition',
      )

      if (!scrollPosition) return

      this.els.facetsDrawer.element.scrollTo(0, scrollPosition)
    })
  }

  renderPagination (pagination) {
    // Toggle next button
    if (pagination.showNextButton) {
      this.els.loadMore.element.removeAttribute('hidden')
    } else {
      this.els.loadMore.element.setAttribute('hidden', '')
    }

    // Toggle previous button
    if (pagination.showPreviousButton) {
      this.els.paginationPrevious.element.removeAttribute('hidden')
    } else {
      this.els.paginationPrevious.element.setAttribute('hidden', '')
    }

    // Toggle back to top
    if (pagination.showing > 10) {
      this.els.backToTops.element.removeAttribute('hidden')
    } else {
      this.els.backToTops.element.setAttribute('hidden', '')
    }

    // Update previous button data on first load
    if (!this.updatedPreviousButton) {
      this.els.loadPrevious.element.dataset.page = pagination.currentPage - 1
      this.els.loadPrevious.element.dataset.from =
        pagination.from - pagination.size
      this.updatedPreviousButton = true
    }

    // Update string
    if (this.els.paginationLabel?.exists) {
      const string = this.els.paginationLabel.element.dataset.format
        .replaceAll('[count]', pagination.showing)
        .replaceAll('[total]', pagination.total)

      this.els.paginationLabel.element.innerHTML = string
    }
  }

  async renderShopifyFallback () {
    try {
      const section =
        this.pageType === 'search'
          ? 'template-search-product-grid'
          : 'template-collection-product-grid'

      const url =
        this.pageType === 'search'
          ? `${window.location.href}&type=product`
          : window.location.href

      const response = await window.BAO.sectionRenderer.fetchSingle(
        section,
        url,
      )

      const newDOM = window.BAO.sectionRenderer.convertToDOM(response)
      const collectionFilters = newDOM.querySelector('collection-filters')

      this.outerHTML = collectionFilters.outerHTML
    } catch (error) {
      console.error(error)
    }
  }

  get pageType () {
    return this.dataset.pageType || 'collection'
  }
}

if (!customElements.get('results-filters')) {
  customElements.define('results-filters', ResultsFilters)
}
